import querystring from 'query-string';

import * as clientErrTypes from 'config/clientErrorTypes';
import { fetches, generateFetchOpts } from 'api/client';

export function getPromoEntriesList(promoId, query = {}) {
    const qs = querystring.stringify(query);
    return fetches(
        `/promotions/${promoId}/entries/list${Boolean(qs) ? `?${qs}` : ''}`,
        generateFetchOpts(),
        {
            dataKeys: 'data',
            throwErrConfigs: { [clientErrTypes.GET_API_ERROR]: r => r.httpStatus !== 200 }
        }
    );
}

export function getPromoEntryResult(promoId, entryId) {
    return fetches(`/promotions/${promoId}/entries/${entryId}/result`, generateFetchOpts(), {
        dataKeys: 'data',
        throwErrConfigs: {
            [clientErrTypes.NOT_FOUND]: r => r.httpStatus === 400 && r.payload.message === '404',
            [clientErrTypes.GET_API_ERROR]: r => r.httpStatus !== 200
        }
    });
}

export function getUgcMediaVoteAndRankingInfo(promoId, mediaUUID) {
    return fetches(`/promotions/${promoId}/media/${mediaUUID}/votes`, generateFetchOpts(), {
        dataKeys: 'data',
        throwErrConfigs: {
            [clientErrTypes.GET_API_ERROR]: r => r.httpStatus !== 200
        }
    });
}

export function getContestUgcMediaAndVoteCount(promoId) {
    return fetches(`/promotions/${promoId}/media/votes`, generateFetchOpts(), {
        dataKeys: 'data',
        throwErrConfigs: {
            [clientErrTypes.GET_API_ERROR]: r => r.httpStatus !== 200
        }
    });
}

export function getMediaCacheTotalCounts({ promoUUID }) {
    return fetches(`/promotions/${promoUUID}/media/counts`, generateFetchOpts(), {
        dataKeys: 'data'
    });
}

export function getMediaCacheData({ promoUUID, firstNum, defaultNum }) {
    return fetches(
        `/promotions/${promoUUID}/media?first=${firstNum}&default=${defaultNum}`,
        generateFetchOpts(),
        { dataKeys: 'data' }
    );
}

export function getAllMediaOfEntry({ promoUUID, entryId }) {
    return fetches(`/promotions/${promoUUID}/entries/${entryId}/user-result`, generateFetchOpts(), {
        dataKeys: 'data'
    });
}
